import React from 'react';
import { Tabs } from 'antd';
import './CustomTab.css';

const CustomTab = ({ entries, onChange, activeKey }) => {


    return (
        <div className='tab_container'>
            <Tabs  activeKey={activeKey} items={entries} onChange={onChange} className='customTab'  />
        </div>
    );
}
export default CustomTab;